import { Injectable } from "@angular/core";
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { DataService } from "./data-service/data-service.service";

export interface PreviewComponent {
    canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
    providedIn: "root"
})
export class AuthGuard implements CanActivate, CanDeactivate<PreviewComponent> {
    constructor(private service: DataService, private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

        if (this.service.checkUserType()) {
            return true;
        } else {
            return false;
        }
    }

    canDeactivate(component: PreviewComponent): boolean | Observable<boolean> {
        if (!this.service.checkUserType()) {
            return true;
        } else {
            return false;
        }
    }
}